var authorizationCache = {};
var doDebugPrint = false;

function authorize(path) {
	var pathAsString = JSON.stringify(path);
	var permissions = globalConfig.user.permissions;
	if (jQuery.isEmptyObject(permissions) || JSON.stringify(permissions) == '{"*":"*"}' || (!path || !path.length)) {
		return true;
	}
	debugPrint('Initial permissions: ', permissions);
	debugPrint('Path to authorize: ' + pathAsString);
	var cachedValue = authorizationCache[pathAsString];
	if (typeof cachedValue !== 'undefined') {
		debugPrint('Cache hit, returning ' + cachedValue);
		return cachedValue;
	}
	var rslt = recursiveAuthorize(permissions, path, 0);
	authorizationCache[pathAsString] = rslt;
	return rslt;
}

function emptyAuthorizationCache() {
	authorizationCache = {};
}


function recursiveAuthorize(permissions, path, iCurrentComponent) {
	debugPrint('Permissions: ', permissions);
	debugPrint('iCurrentComponent: ' + iCurrentComponent);
	if (permissions.constructor === Array) {
		debugPrint('Is array');
		for (var i = 0; i < permissions.length; i++) {
			var element = permissions[i];
			if (recursiveAuthorize(element, path, iCurrentComponent)) {
				return true;
			}
		}
		return false;
	}
	if (permissions.constructor === Object) {
		debugPrint('Is object');
		var subTree = permissions[path[iCurrentComponent]];
		if (typeof subTree === 'undefined') {
			debugPrint('Could not find element ' + path[iCurrentComponent]);
			return false;
		}
		if (iCurrentComponent === path.length - 1) {
			debugPrint('Reached end of path successfully');
			return true;
		}
		debugPrint('Found path component ' + path[iCurrentComponent]);
		return recursiveAuthorize(subTree, path, iCurrentComponent + 1);
	}
	// Leaf node
	if (permissions === '*') {
		debugPrint('Ran into allow all node, success');
		return true;
	}
	if (path[iCurrentComponent] === permissions) {
		debugPrint('Found matching leaf node: ' + path[iCurrentComponent]);
		if (iCurrentComponent === path.length - 1) {
			debugPrint('Reached end of path, success');
			return true;
		}
	}
	debugPrint('No match, fail');
	return false;
}

function debugPrint(s, o) {
	if (doDebugPrint) {
		var objStr = '';
		if (typeof o != 'undefined') {
			objStr = JSON.stringify(o);
		}
		// eslint-disable-next-line no-console
		console.log(s + objStr);
	}
}
